enum InterestPaymentMethodEnum {
    Monthly = 'MONTHLY',
    Prepaid = 'PREPAID',
}

export default InterestPaymentMethodEnum;
